<template>
    <v-card class="flex pa-0 background-2 round-card" v-if="!$store.getters.progress">
        <v-card-title class="pa-3">
            <p class="pl-2 pl-xl-3">Fatturato</p>
            <v-spacer></v-spacer>
            <v-tooltip v-if="!showTable" top>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="showTable = !showTable" icon>
                        <v-icon>storage</v-icon>
                    </v-btn>
                </template>
                <span>Visualizza Tabella</span>
            </v-tooltip>
            <v-tooltip v-else top>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="showTable = !showTable, loadChart = true" icon>
                        <v-icon>equalizer</v-icon>
                    </v-btn>
                </template>
                <span>Visualizza Grafico</span>
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="exportCSV()" icon :disabled="items.length == 0">
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                </template>
                <span>Esporta CSV</span>
            </v-tooltip>
        </v-card-title>                
        <v-divider></v-divider>
        <v-container class="pa-0 pt-4" fluid>
            <fields-generator
                class="pt-4"
                :fieldsset.sync="fieldsset"
                :model="model" 
                ref="fieldsgenerator"
            ></fields-generator>
        </v-container>

        <v-data-table v-if="showTable && loaded"
            class="background-2"
            :headers="categoryHeaders"
            :items="items"
            hide-default-footer
            disable-pagination
            >
            <template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
                <tr class="cursor-pointer" @click="expand(!isExpanded)">
                    <template v-for="(header, h) in categoryHeaders">
                        <td :key="h" v-if="header.value == 'revenue'">
                            {{ item[header.value] | currency }}
                        </td>
                        <td :key="h" v-else style="width: 50%;">
                            {{ item[header.value] }}
                        </td>
                    </template>
                </tr>
            </template>
            <template v-slot:expanded-item="{ item, headers }">
                <tr>
                    <td :colspan="headers.length">                        
                        <v-card class="background-2 elevation-0">
                            <v-card-text class="theme--light blue-background-1">
                                <v-data-table
                                    :headers="subCategoryHeaders"
                                    :items="item.subcategories"
                                    hide-default-footer
                                    disable-pagination
                                    class="background-2 elevation-1">
                                    <template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
                                        <tr class="cursor-pointer" @click="expand(!isExpanded)">
                                            <template v-for="(head, hh) in subCategoryHeaders">
                                                <td :key="hh" v-if="head.value == 'revenue'">
                                                    {{ item[head.value] | currency }}
                                                </td>
                                                <td :key="hh" v-else style="width: 70%;">
                                                    {{ item[head.value] }}
                                                </td>
                                            </template>
                                        </tr>
                                    </template>
                                    <template v-slot:expanded-item="{ item, headers }">
                                        <tr>
                                            <td :colspan="headers.length">                                                 
                                                <v-card class="background-2 elevation-0">
                                                    <v-card-text class="theme--light blue-background-2">
                                                        <v-data-table 
                                                            :headers="companyHeaders"
                                                            :items="item.subcategories"
                                                            hide-default-footer
                                                            disable-pagination
                                                            class="background-2 elevation-1">
                                                            <template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
                                                                <tr class="cursor-pointer">
                                                                    <template v-for="(he, hhh) in companyHeaders">
                                                                        <td :key="hhh" v-if="he.value == 'revenue'">
                                                                            {{ item[he.value] | currency }}
                                                                        </td>
                                                                        <td :key="hhh" v-else style="width: 100%;">
                                                                            {{ item[he.value] }}
                                                                        </td>
                                                                    </template>
                                                                </tr>                                            
                                                            </template>
                                                        </v-data-table>
                                                    </v-card-text>
                                                </v-card>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </td>
                </tr>
            </template>
            <template v-slot:footer.page-text="{ pageStart, pageStop }">
                <div class="warning--text"><span class="warning--text">{{ countSelected }}</span> Selezionati</div>
                Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
            </template>
        </v-data-table>
        <v-divider></v-divider>
        <v-row class="ma-0 pt-2 pb-2"  justify="center">
            <v-col lg="2" md="2" sm="6">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-currency-eur</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Totale Fatturato</v-list-item-title>
                            <v-list-item-subtitle>{{ totals | currency(2) }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
        </v-row>
        <v-row class="ma-0 pt-2 pb-2" v-if="!showTable && loadChart"  justify="center">
            <v-col lg="12">
                <sunburst-chart v-if="items.length > 0"
                    :chart-data="items"
                ></sunburst-chart>
            </v-col>                
        </v-row>
    </v-card>
</template>

<script>

    import Vue from 'vue'
    import SunburstChart from '@/components/common/SunburstChart'

    export default {
        name: 'revenue-categories',
        components: {
            SunburstChart
        },

        props: {
			url: {
				type: String,
				default: 'revenuecategories'
            }
        },

        data() {
            return {
                fieldsset: {},
                categoryHeaders: [
                    {
                        'text': 'Categoria',
                        'value': 'category_name'
                    },
                    {
                        'text': 'Fatturato per Categoria',
                        'value': 'revenue'
                    }
                ],
                subCategoryHeaders: [
                    {
                        'text': 'Sotto Categoria',
                        'value': 'category_name'
                    },
                    {
                        'text': 'Fatturato per Sottocategoria',
                        'value': 'revenue'
                    }
                ],
                companyHeaders: [
                    {
                        'text': 'Azienda',
                        'value': 'category_name'
                    },
                    {
                        'text': 'Fatturato per  Azienda',
                        'value': 'revenue'
                    }
                ],
                model: {},
                items: [],
                showTable: true,
                loaded: false,
                loadChart: false,
            }
        },


        created() {
            this.axios.get(this.url + '-info').then(response => {
                // get body data
                this.fieldsset = response.data.info
                this.headers = response.data.info.headers

                _.forEach(this.fieldsset.fields, (value, key) => {
                    if(value.key == 'year' && value.default) {
                        Vue.set(this.model, value.key, value.default)
                    }
                })

                this.$store.commit('endProgress')
				this.loaded = true

            }, response => {
                // error callback
            })
        },

        watch: {
            model: {
                handler() {
                    this.getData()
                },
                deep: true,
            }
        },

        computed: {
            totals() {
                let totalRevenue = this.items.reduce((acc, item) => {
                    return acc + item.revenue;
                }, 0)
                return totalRevenue
            },
        },

        methods: {

            getData() {

                this.loading = "warning"

                this.axios.post(this.url, this.model).then(response => {
                    this.items = response.data.data
                    this.loading = false

                }, response => {
                    // error callback
                })
            },

            exportCSV() {
                const headers = [
                    { text: 'AZIENDA', value: 'azienda' },
                    { text: 'CATEGORIA', value: 'categoria' },
                    { text: 'SOTTOCATEGORIA', value: 'sottocategoria' },
                    { text: 'FATTURATO', value: 'fatturato' }
                ]

                const flatData = []

                this.items.forEach(category => {
                    const categoryName = category.category_name

                    if (category.subcategories && category.subcategories.length > 0) {
                        category.subcategories.forEach(subcategory => {
                            const subcategoryName = subcategory.category_name

                            if (subcategory.subcategories && subcategory.subcategories.length > 0) {
                                subcategory.subcategories.forEach(company => {
                                    flatData.push({
                                        azienda: company.category_name,
                                        categoria: categoryName,
                                        sottocategoria: subcategoryName,
                                        fatturato: company.revenue
                                    })
                                })
                            }
                        })
                    }
                })

                this.$eventBusUtility.exportCSV(headers, flatData, 'Fatturato_per_Categoria')
            },
        },
    }
</script>

<style>

</style>
